export default class StaticSlider {
  constructor(options) {
    this.$container = options.$el;

    this.$el = this.$container.querySelector(".js-static-slider");

    this.currentIndexPush = 0;

    this._prev = this.prev.bind(this);
    this._next = this.next.bind(this);

    this.$pushes = [].slice.call(this.$el.children);
    this.$pushes.forEach((push) => {
      push.setAttribute("aria-hidden", "true");
    });

    this.showFirstPush();

    this.setEvents();
  }

  showFirstPush() {
    if (!!this.$pushes && !!this.$pushes[this.currentIndexPush]) {
      this.$pushes[0].classList.add("is-active");
      this.$pushes[0].removeAttribute("aria-hidden");
    }
  }

  prev(e) {
    e.preventDefault();
    this.nextWay = -1;
    this.updatePush();
  }

  next(e) {
    e.preventDefault();
    this.nextWay = 1;
    this.updatePush();
  }

  updatePush() {
    let active = this.$pushes[this.currentIndexPush];

    active.classList.remove("is-active");
    active.setAttribute("aria-hidden", "true");

    //Increment index
    this.currentIndexPush += this.nextWay;
    if (this.currentIndexPush > this.$pushes.length - 1) {
      this.currentIndexPush = 0;
    } else if (this.currentIndexPush < 0) {
      this.currentIndexPush = this.$pushes.length - 1;
    }

    active = this.$pushes[this.currentIndexPush];

    this.raf = window.requestAnimationFrame(() => {
      this.raf = window.requestAnimationFrame(() => {
        active.classList.add("is-active");
        active.removeAttribute("aria-hidden");
      });
    });
  }

  setEvents() {
    if (this.$pushes.length > 1) {
      this.$container.querySelectorAll(".js-slider-prev").forEach((element) => {
        element.addEventListener("click", this._prev);
      });

      this.$container.querySelectorAll(".js-slider-next").forEach((element) => {
        element.addEventListener("click", this._next);
      });
    }
  }

  removeEvents() {
    if (this.$pushes.length > 1) {
      this.$container.querySelectorAll(".js-slider-prev").forEach((element) => {
        element.removeEventListener("click", this._prev);
      });
      this.$container.querySelectorAll(".js-slider-next").forEach((element) => {
        element.removeEventListener("click", this._next);
      });
    }
  }

  destroy() {
    this.removeEvents();
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/StaticSlider.js